export default __webpack_public_path__ + "static/media/atlasLogoDark.1dbe1b3f.png";